import { createSelector } from "@reduxjs/toolkit";
import memoize from "lodash/memoize";

import { SavedViewsState } from "./SavedViewsProvider";

const selectSelf = (state: RootState): SavedViewsState => state.savedViews;
const selectAllSavedViews = createSelector(selectSelf, (state) => state.views || {});

export const selectLoading = createSelector(selectSelf, (state) => state.loading);

export const selectSavedViews = createSelector(selectAllSavedViews, (savedViews) =>
    memoize((page: string) => savedViews[page]?.items || [])
);

export const selectSelectedSavedViewId = createSelector(selectAllSavedViews, (savedViews) =>
    memoize((page: string) => savedViews[page]?.selected_id || null)
);

export const selectDefaultSavedView = createSelector(
    selectAllSavedViews,
    (savedViews) => (page: string) => savedViews[page]?.items?.find((item) => item?.isDefault) || null
);
